import {Component, inject, OnInit} from '@angular/core';
import {HeaderComponent} from "../../common/header/header.component";
import {IonContent, IonImg} from "@ionic/angular/standalone";
import {ActivatedRoute, RouterLink} from "@angular/router";
import {BlogService} from '../blog.service';
import {DomSanitizer, Meta, Title} from '@angular/platform-browser';
import {FooterComponent} from '../../common/footer/footer.component';
import {B2bSectionComponent} from '../../pages/components/b2b-section/b2b-section.component';
import {DatePipe} from '@angular/common';

@Component({
    selector: 'app-post',
    templateUrl: './post.component.html',
    styleUrls: ['./post.component.scss'],
  imports: [
    HeaderComponent,
    IonContent,
    IonImg,
    FooterComponent,
    B2bSectionComponent,
    DatePipe
  ]
})
export class PostComponent  implements OnInit {

  blog = [
    { title: 'A Guide to Renting in Riyadh', description: '', image: '/assets/home/blog/A_Guide_to_Renting_in_Riyadh.png' },
    { title: '6 Key Strategies for Successful Property Management in Riyadh', description: '', image: '/assets/home/blog/6_Key_Strategies_for_Successful_Property_Management_in_Riyadh.png' },
    { title: 'Riyadh\'s Luxury Real Estate Market: A Guide to High-End Living', description: '', image: '/assets/home/blog/Riyadh\'s_Luxury_Real_Estate_Market_A_Guide_to_HighEnd_Living.png' }
  ]
  route: ActivatedRoute = inject(ActivatedRoute);
  post: any;
  blogService: BlogService = inject(BlogService);
  sanitizer: DomSanitizer = inject(DomSanitizer);
  constructor() { }

  title: Title = inject(Title);
  meta: Meta = inject(Meta);
  async ngOnInit() {
    this.route.params.subscribe(async (params: any) => {
      this.post = await this.blogService.getPost(params.id);
      this.post.sanitizedHtml = this.sanitizer.bypassSecurityTrustHtml(this.post.post);

      this.title.setTitle(this.post.title);

      this.meta.addTags([
        {property: 'og:title', content: this.post.title},
        {name: 'description', content: ''},
        {property: 'og:description', content: ''},
        {property: 'og:image', content: ''},
        {property: 'og:site_name', content: 'satel.sa'},
        {property: 'og:url', content: `https://satel.sa/`},
        {property: 'og:type', content: 'article'},
        {name: 'twitter:site', content: 'satel.sa'},
        {name: 'twitter:title', content: this.post.title},
        {name: 'twitter:description', content: ''},
        {name: 'twitter:card', content: 'summary'},
        {name: 'twitter:image', content: ''}
      ]);
    })
  }

}
